import './styles.scss';

import React, { FC } from 'react';

import { FooterLinkModel } from '../../../../models/footerLink.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { TFooterLink } from '../../../../types/footerLink.types';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const DealerLogin: FC<TFooterLink> = (props) => {
  const model = new FooterLinkModel(props);
  return (
    <div className="dealer-login">
      {model?.title && <Text tag="div" field={model?.title} className="dealer-login__text" />}
      <div className="dealer-login__cta">
        <RoutableSitecoreLink field={model?.list[0]?.fields?.link} />
      </div>
    </div>
  );
};

export default DealerLogin;
